/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { Button as o } from "@progress/kendo-react-buttons";
import { xIcon as r } from "@progress/kendo-svg-icons";
const s = ({
  children: e,
  onCloseButtonClick: a,
  id: i,
  closeIcon: l
}) => /* @__PURE__ */ t.createElement("div", { className: "k-window-titlebar k-dialog-titlebar", id: i }, /* @__PURE__ */ t.createElement("span", { className: "k-window-title k-dialog-title" }, e), l && /* @__PURE__ */ t.createElement("div", { className: "k-window-titlebar-actions k-dialog-titlebar-actions" }, /* @__PURE__ */ t.createElement(
  o,
  {
    role: "button",
    "aria-label": "Close",
    onClick: a,
    icon: "x",
    svgIcon: r,
    fillMode: "flat",
    className: "k-window-titlebar-action k-dialog-titlebar-action"
  }
)));
export {
  s as DialogTitleBar
};
